/* Appliances */
export const GET_APPLIANCE_DATA = "GET_APPLIANCE_DATA";
export const GET_APPLIANCE_DATA_SUCCESS = "GET_APPLIANCE_SUCCESS";
export const GET_APPLIANCE_DATA_FAILURE = "GET_APPLIANCE_FAILURE";

export const REGISTER_APPLIANCE = "REGISTER_APPLIANCE";
export const REGISTER_APPLIANCE_SUCCESS = "REGISTER_APPLIANCE_SUCCESS";
export const REGISTER_APPLIANCE_ERROR = "REGISTER_APPLIANCE_ERROR";

export const EDIT_APPLIANCE = "EDIT_APPLIANCE";
export const EDIT_APPLIANCE_SUCCESS = "EDIT_APPLIANCE_SUCCESS";
export const EDIT_APPLIANCE_ERROR = "EDIT_APPLIANCE_ERROR";

export const EDIT_CAMERA = "EDIT_CAMERA";
export const EDIT_CAMERA_SUCCESS = "EDIT_CAMERA_SUCCESS";
export const EDIT_CAMERA_ERROR = "EDIT_CAMERA_ERROR";

export const UPDATE_CAMERA_TIME = "UPDATE_CAMERA_TIME";
export const UPDATE_CAMERA_TIME_SUCCESS = "UPDATE_CAMERA_TIME_SUCCESS";
export const UPDATE_CAMERA_TIME_ERROR = "UPDATE_CAMERA_TIME_ERROR";

export const APPLIANCE_ACTION_ERROR = "APPLIANCE_ACTION_ERROR";
